import React, { Component } from 'react';
import { Form, Col, Table, Button, Collapse, Nav, Alert } from 'react-bootstrap';
import { FcPlus, FcHome, FcPaid, FcShipped } from "react-icons/fc";
import config from '../../../config';
import Numeroaletras from '../../../middleware/numbertoletter';
import CardItem from '../../subcomponent/cardItem';
import SearchItem from '../../subcomponent/searchItem';
import SearchCliente from '../../subcomponent/searchClient';

class Pedidos extends Component {
    constructor(props) {
        const currentCompany = sessionStorage.getItem('company');
        const currentUserType = sessionStorage.getItem('tipo');
        const currentUser = sessionStorage.getItem('vendedor');
        super(props);
        this.state = {
            data: [],
            empresa: currentCompany,
            tipo: currentUserType,
            currentUser,
            clientes: [],
            forma_pago: [],
            vendedores: [],
            retenciones: [],
            promociones: [],
            showAlert: false,
            showAlertError: false,
            mensajeerror: "",
            showAlertItem: false,
            numeroDocumento: 0,
            FORMA_PAGO: "",
            NUMERO_FACTURA: 0,
            FECHA_ENTREGA: "",
            CLIENTE: "",
            cod_lista: "",
            RENTA: 0,
            RETEIVA: 0,
            RETEICA: 0,
            RETEOTROS: 0,
            VENDEDOR_SELECTED: "",
            OBSERVACION_FACTURA: "",
            ORDEN_COMPRA: "",
            tope: 100,
            bodegadefault: "",
            changeFormaPago: 0,
            SHOW_DETAIL: false,
            data_items: [],
            detalle_factura: [],
            data_cliente: [],
            totales: {
                TOTAL_BRUTO: 0,
                RETENCION: 0,
                TOTAL_IVA: 0,
                SUBTOTAL: 0,
                TOTAL_DESCUENTOS: 0,
                TOTAL_PAGAR: 0
            },
            showCabecera: true,
            showDetalle: false,
            showTotales: false,
            showNuevo: false,
            CANTIDAD: 0,
            DESCUENTO: 0,
            VALOR_UNI: 0,
            CONTROL_VALOR_UNI: 0,
            PORCENTAJE_IVA: 0,
            ID_ITEMS: "",
            DESCRIPCION_ITEM: "",
            UNIDAD_VENTA: "",
            ITEM_SELECT: -1
        };
    }
    componentDidMount() {
        this.initFactura();
    }

    initFactura = () => {
        const today = new Date();
        const dd = String(today.getDate()).padStart(2, '0');
        const mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!mm
        const yyyy = today.getFullYear();
        const cfecha = yyyy + "-" + mm + "-" + dd;
        const { currentUser } = this.state;
        const datasend = {
            method: 'GET',

            headers: {
                'Content-Type': 'application/json',
                'empresa': this.state.empresa,
                'tipo': 'PE',
                'currentUser': currentUser,
            }
        }
        fetch(config.servBackEnd + '/invoice/', datasend).then(response => response.json())
            .then(data => {
                ////console.log(data);
                const cData = data.data;
                const clientes = cData[0];
                const forma_pago = cData[2];
                const vendedores = cData[3];
                const retenciones = cData[4];
                const infovendedor = cData[8];
                let tope = 100;
                let bodegadefault = "";
                let changeFormaPago = 0;
                if (infovendedor.length > 0) {
                    tope = infovendedor[0]["TOPE_DSCTO"];
                    bodegadefault = infovendedor[0]["BODEGA"];
                    changeFormaPago = infovendedor[0]["FORMA_PAGO"];
                }
                this.setState({
                    clientes,
                    forma_pago,
                    vendedores,
                    retenciones,
                    tope,
                    bodegadefault,
                    changeFormaPago,
                    FORMA_PAGO: "",
                    NUMERO_FACTURA: 0,
                    FECHA_ENTREGA: cfecha,
                    CLIENTE: "",
                    SHOW_DETAIL: false
                });
                this.clearItem();
            });
    }

    changeCantidad = ({ target }) => {
        const { ID_ITEMS, CONTROL_VALOR_UNI, promociones } = this.state;
        let { value } = target;
        const { name } = target;
        if (name === "DESCUENTO" && value > 100) value = 100;
        if (name === "CANTIDAD") {
            const actprom = promociones.find((promo) => promo.ID_ITEM === ID_ITEMS && promo.CANT_FINAL >= value && promo.CANT_INICIAL <= value) //  )
            const VALOR_UNI = (actprom) ? actprom.VALOR : CONTROL_VALOR_UNI;
            this.setState({ CANTIDAD: value, VALOR_UNI })
        };
        if (name === "DESCUENTO") this.setState({ DESCUENTO: value });
        if (name === "VALOR_UNI") this.setState({ VALOR_UNI: value });
        // if(cod_lista !== 0){
        //     const actprom = promociones.find((promo)=> promo.ID_ITEM === element.ID_ITEMS && promo.CANT_FINAL >= parseInt(element.CANTIDAD, 10) && promo.CANT_INICIAL <= parseInt(element.CANTIDAD, 10) ) //  )
        //     element.VALOR_UNI = (actprom) ? actprom.VALOR : element.CONTROL_VALOR_UNIDAD;
        // };
    }

    calcTotales = () => {
        const newDetalle = this.state.detalle_factura;
        const { retenciones } = this.state;
        const { data_cliente } = this.state;
        let RENTA = 0;
        let RETEIVA = 0;
        let RETEICA = 0;
        let RETEOTROS = 0;
        let TOTAL_BRUTO = 0;
        let RETENCION = 0;
        let TOTAL_IVA = 0;
        let SUBTOTAL = 0;
        let TOTAL_DESCUENTOS = 0;
        let TOTAL_PAGAR = 0;
        newDetalle.forEach(element => {
            element.TOTAL = element.CANTIDAD * element.VALOR_UNI;
            element.VALOR_DCTO = element.TOTAL * element.DESCUENTO / 100;
            element.VALOR_IVA = (element.TOTAL - element.VALOR_DCTO) * element.PORCENTAJE_IVA / 100;
            TOTAL_BRUTO += element.TOTAL;
            TOTAL_IVA += element.VALOR_IVA;
            TOTAL_DESCUENTOS += element.VALOR_DCTO;
            SUBTOTAL = TOTAL_BRUTO - TOTAL_DESCUENTOS;
            TOTAL_PAGAR = TOTAL_BRUTO - TOTAL_DESCUENTOS + TOTAL_IVA;
        });

        ////console.log(data_cliente[0][0].LIQUIDA_RENTA);

        if (data_cliente[0].LIQUIDA_RENTA) {
            retenciones.forEach(element => {
                if (element.TIPO_RETENCION === "1") {
                    RENTA += (element.BASE_MINIMA_VENTA <= SUBTOTAL) ? SUBTOTAL * element.PORCENTAJE_RETENCION / 100 : 0;
                    RETENCION += RENTA;
                }
            });
        }

        if (data_cliente[0].LIQUIDA_RETEIVA) {
            retenciones.forEach(element => {
                if (element.TIPO_RETENCION === "2") {
                    RETEIVA += (element.BASE_MINIMA_VENTA <= SUBTOTAL) ? TOTAL_IVA * element.PORCENTAJE_RETENCION / 100 : 0;
                    RETENCION += RETEIVA;
                }
            });
        }

        if (data_cliente[0].LIQUIDA_RETEICA) {
            retenciones.forEach(element => {
                if (element.TIPO_RETENCION === "3") {
                    RETEICA += (element.BASE_MINIMA_VENTA <= SUBTOTAL) ? SUBTOTAL * element.PORCENTAJE_RETENCION / 100 : 0;
                    RETENCION += RETEICA;
                }
            });
        }

        if (data_cliente[0].LIQUIDA_RETEOTROS) {
            retenciones.forEach(element => {
                if (element.TIPO_RETENCION === "4") {
                    RETEOTROS += (element.BASE_MINIMA_VENTA <= SUBTOTAL) ? SUBTOTAL * element.PORCENTAJE_RETENCION / 100 : 0;
                    RETENCION += RETEOTROS;
                }
            });
        }

        TOTAL_PAGAR -= RETENCION;

        const newTotal = {
            TOTAL_BRUTO,
            RETENCION,
            TOTAL_IVA,
            SUBTOTAL,
            TOTAL_DESCUENTOS,
            TOTAL_PAGAR
        }

        this.setState({
            RENTA,
            RETEIVA,
            RETEICA,
            RETEOTROS,
            detalle_factura: newDetalle,
            totales: newTotal
        })
    }

    changeItem = (itemSelect) => {
        const { promociones } = this.state;
        const actprom = promociones.find((promo) => promo.ID_ITEM === itemSelect.ID_ITEMS && promo.CANT_FINAL >= 1 && promo.CANT_INICIAL <= 1) //  )
        const valor_promo = (actprom) ? actprom.VALOR : itemSelect.PRECIO;

        this.setState({
            ID_ITEMS: itemSelect.ID_ITEM,
            UNIDAD_VENTA: itemSelect.UNIDAD_VENTA,
            DESCRIPCION_ITEM: itemSelect.DESCRIPCION_ITEM,
            CANTIDAD: 1,
            DESCUENTO: (this.state.data_cliente[0] && this.state.data_cliente[0].DESCUENTO) || 0,
            VALOR_UNI: valor_promo,
            CONTROL_VALOR_UNI: itemSelect.PRECIO,
            showAlertItem: false
        })
    }

    removeitem = (index) => {
        let newData = this.state.detalle_factura;
        newData.splice(index, 1);
        this.setState({ detalle_factura: newData });
        this.calcTotales();
    }

    modifyitem = (index) => {
        const tmp_detalle = this.state.detalle_factura;
        tmp_detalle.forEach((element, i) => {
            if (i === index) {
                console.log(element);
                this.setState({
                    ITEM_SELECT: index,
                    ID_ITEMS: element.ID_ITEMS,
                    DESCRIPCION_ITEM: element.DESCRIPCION_ITEM,
                    CANTIDAD: element.CANTIDAD,
                    DESCUENTO: element.DESCUENTO,
                    VALOR_UNI: element.VALOR_UNI,
                    CONTROL_VALOR_UNI: element.CONTROL_VALOR_UNI,
                    showCabecera: false,
                    showDetalle: false,
                    showTotales: false,
                    showNuevo: true,
                    showAlertItem: false
                })
            }
        });
    }

    changeCliente = (selectClient) => {
        const value = selectClient.ID_CLIENTES;
        let showDetail = false;
        if (value) {
            showDetail = true;
            const datasend = {
                method: 'GET',

                headers: {
                    'Content-Type': 'application/json',
                    'empresa': this.state.empresa,
                    'tipo': this.state.tipo,
                }
            }
            fetch(config.servBackEnd + '/invoice/detail/' + value, datasend).then(response => response.json())
                .then(data => {
                    const cData = data.data;
                    const cCliente = cData[0];
                    const cItems = cData[1];
                    const promociones = cData[3];
                    const vend = cCliente[0]["VENDEDOR_ASOCIADO"];
                    const list = cCliente[0]["LISTA_CLIENTE"];
                    const formapag = cCliente[0]["FORMA_PAGO_CLIENTE"];
                    this.setState({
                        CLIENTE: value,
                        cod_lista: list,
                        SHOW_DETAIL: showDetail,
                        data_items: cItems,
                        data_cliente: cCliente,
                        VENDEDOR_SELECTED: vend,
                        FORMA_PAGO: formapag,
                        promociones
                    });
                    this.clearItem();
                });
        } else {
            //console.log("Seleccione un cliente");
        };

    }

    clearItem = () => {
        this.setState({
            detalle_factura: [],
            totales: {
                TOTAL_BRUTO: 0,
                RETENCION: 0,
                TOTAL_IVA: 0,
                SUBTOTAL: 0,
                TOTAL_DESCUENTOS: 0,
                TOTAL_PAGAR: 0
            },
            RENTA: 0,
            RETEIVA: 0,
            RETEICA: 0,
            RETEOTROS: 0
        })

    }

    saveInvoice = (event) => {
        event.preventDefault();
        //console.log("guardar");
        const today = new Date();
        const dd = String(today.getDate()).padStart(2, '0');
        const mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!mm
        const yyyy = today.getFullYear();
        const todayFormat = yyyy + "-" + mm + "-" + dd;

        const cliente = this.state.data_cliente[0];
        const { totales } = this.state;
        const { forma_pago } = this.state;
        const { vendedores } = this.state;
        //const { retenciones } = this.state;
        const { detalle_factura } = this.state;
        const valorTexto = Numeroaletras(totales.TOTAL_PAGAR);
        let currentForma = []
        forma_pago.forEach(element => {
            if (element.ID_FORMAS_PAGO.toString() === this.state.FORMA_PAGO.toString()) {
                currentForma = element;
            }
        });
        let currentVend = []
        vendedores.forEach(element => {
            if (element.ID_USUARIO.toString() === this.state.VENDEDOR_SELECTED.toString()) {
                currentVend = element;
            }
        });

        const subtotal_send = totales.SUBTOTAL + totales.TOTAL_DESCUENTOS + totales.TOTAL_IVA;
        const Cabecera = {
            ID_EMPRESA: this.state.empresa,
            CODIGO_EMPRESA: '01',
            CENTRO_OPERACION: '01',
            NUMERO_FACTURA_CABECERA: this.state.NUMERO_FACTURA,
            TIPO_DOCUMENTO_CABECERA: currentVend.PEDIDO,
            NUMERO_REMISION: "",
            NUMERO_PEDIDO: "",
            DOCUMENTO_ALTERNO: "",
            ID_TRANSACCION: "",
            DOCUMENTO_CLIENTE: cliente.DOCUMENTO_CLIENTE,
            DIGITO_VERIFICACION_CLIENTE: cliente.DV_CLIENTE,
            TIPO_IDENTIFICACION_CLIENTE: cliente.TIPO_IDENTIFICACION,
            NOMBRE_CLIENTE: cliente.NOMBRE_CLIENTE,
            DIRECCION_CLIENTE: cliente.DIRECCION_CLIENTE,
            DEPARTAMENTO_CLIENTE: cliente.NOMBRE_DEPARTAMENTO_CLIENTE,
            CODIGO_POSTAL: cliente.CODIGO_POSTAL,
            CIUDAD_CLIENTE: cliente.NOMBRE_CIUDAD_CLIENTE,
            CODIGO_DEPARTAMENTO_CLIENTE: cliente.CODIGO_DEPARTAMENTO_CLIENTE,
            CODIGO_CIUDAD_CLIENTE: cliente.CODIGO_CIUDAD_CLIENTE,
            TELEFONO_CLIENTE: cliente.TELEFONO_FIJO_CLIENTE,
            EMAIL_CLIENTE: cliente.EMAIL_CLIENTE,
            VENDEDOR: currentVend.NOMBRE_COMPLETO,
            FECHA_DOCUMENTO: todayFormat,
            FECHA_VENCIMIENTO_DOCUMENTO: this.state.FECHA_ENTREGA,
            FECHA_DOCUMENTO_ALTERNO: "",
            PORCENTAJE_IVA: 0,
            PORCENTAJE_IMPOCONSUMO: 0,
            TOTAL_BRUTO: totales.TOTAL_BRUTO,
            TOTAL_DESCUENTO_LINEA: totales.TOTAL_DESCUENTOS,
            TOTAL_DESCUENTO_GLOBAL: 0,
            TOTAL_IVA: totales.TOTAL_IVA,
            TOTAL_IMPOCONSUMO: 0,
            TOTAL_RETENCION: totales.RETENCION,
            RET_IVA: this.state.RETEIVA,
            RET_ICA: this.state.RETEICA,
            RET_FUENTE: this.state.RENTA,
            RET_OTROS: this.state.RETEOTROS,
            SUBTOTAL: subtotal_send,
            TOTAL_VENTA: totales.TOTAL_PAGAR,
            CONDICION_PAGO: currentForma.DESCRIPCION_FORMA_PAGO,
            VALOR_LETRAS: valorTexto,
            TASA_MONEDA: "1",
            TIPO_MONEDA: "COP",
            OBSERVACION1: this.state.OBSERVACION_FACTURA,
            OBSERVACION2: "",
            BARRIO: cliente.BARRIO_CLIENTE,
            CODIGO_VENDEDOR: currentVend.CODIGO_VENDEDORES
        }

        let Detalle = []
        detalle_factura.forEach((element, index) => {
            if (element.DESCRIPCION_ITEM !== "") {
                Detalle.push(
                    {
                        ID_EMPRESA: this.state.empresa,
                        CODIGO_EMPRESA: '01',
                        CENTRO_OPERACION: '01',
                        NUMERO_FACTURA_DETALLE: this.state.NUMERO_FACTURA,
                        TIPO_DOCUMENTO_DETALLE: currentVend.PEDIDO,
                        INDICE_ITEM: index + 1,
                        ITEM_ID: element.ID_ITEMS,
                        ITEM_DESCRIPCION: element.DESCRIPCION_ITEM,
                        SERIAL: "",
                        UNIDAD_MEDIDA: element.UNIDAD_VENTA,
                        CANTIDAD_1: element.CANTIDAD,
                        CANTIDAD_2: 0,
                        PRECIO_UNITARIO_DETALLE: element.VALOR_UNI,
                        TOTAL_BRUTO_DETALLE: element.TOTAL,
                        DESCUENTO_LINEA_DETALLE: element.VALOR_DCTO,
                        IVA_DETALLE: element.VALOR_IVA,
                        IMPOCONSUMO_DETALLE: 0,
                        PORCENTAJE_IVA_DETALLE: element.PORCENTAJE_IVA,
                        PORCENTAJE_IMPOCONSUMO_DETALLE: 0,
                        PORCENTAJE_DESCUENTO_DETALLE: element.DESCUENTO
                    }
                )
            }
        });

        const factura = {
            Tipo: "P",
            Cabecera,
            Detalle
        }

        const datasend = {
            method: 'POST',
            body: JSON.stringify(factura),
            headers: {
                'Content-Type': 'application/json',
                'empresa': this.state.empresa,
                'tipo': this.state.tipo,
                'currentUser': this.state.currentUser,
            }
        };

        fetch(config.servBackEnd + '/invoice/create', datasend).then(response => response.json())
            .then(data => {
                if (data.ok) {
                    this.setState({ showAlert: true, showAlertItem: false, numeroDocumento: data.DOCUMENTO_CREADO });
                    this.initFactura();
                } else {
                    this.setState({ showAlertError: true, showAlertItem: false, mensajeerror: data.message });
                }
            });


    }

    changetocab = () => {
        this.setState({
            showCabecera: true,
            showDetalle: false,
            showTotales: false,
            showNuevo: false,
            showAlertItem: false
        })
    }
    changetodet = () => {
        this.setState({
            showCabecera: false,
            showDetalle: true,
            showTotales: false,
            showNuevo: false,
            showAlertItem: false
        })
    }
    changetotot = () => {
        this.setState({
            showCabecera: false,
            showDetalle: false,
            showTotales: true,
            showNuevo: false,
            showAlertItem: false
        })
    }
    changetonew = () => {
        this.setState({
            showCabecera: false,
            showDetalle: false,
            showTotales: false,
            showNuevo: true,
            showAlertItem: false
        })
    }

    candelEdit = () => {
        this.setState({
            ITEM_SELECT: -1,
            DESCRIPCION_ITEM: "",
            CANTIDAD: "",
            DESCUENTO: "",
            VALOR_UNI: "",
            CONTROL_VALOR_UNI: "",
            showCabecera: false,
            showDetalle: true,
            showTotales: false,
            showNuevo: false,
            showAlertItem: false
        })
    }

    updateItem = () => {
        const { ITEM_SELECT } = this.state;
        const tmp_detail = this.state.detalle_factura;

        tmp_detail.forEach((element, i) => {
            if (i === ITEM_SELECT) {
                element.CANTIDAD = this.state.CANTIDAD;
                element.DESCUENTO = this.state.DESCUENTO;
                element.VALOR_UNI = this.state.VALOR_UNI;
            }
        });
        this.setState({ detalle_factura: tmp_detail });
        this.calcTotales();
        this.candelEdit();
    }

    addItem = (event) => {
        event.preventDefault();
        const newdetalle = this.state.detalle_factura;
        const { ID_ITEMS } = this.state;
        const { DESCRIPCION_ITEM } = this.state;
        const { CANTIDAD } = this.state;
        const { DESCUENTO } = this.state;
        const { VALOR_UNI } = this.state;
        const { VALOR_DCTO } = this.state;
        const { VALOR_IVA } = this.state;
        const { UNIDAD_VENTA } = this.state;
        const { CONTROL_VALOR_UNI } = this.state;

        newdetalle.push({
            ID_ITEMS: ID_ITEMS,
            DESCRIPCION_ITEM: DESCRIPCION_ITEM,
            UNIDAD_VENTA: UNIDAD_VENTA,
            CANTIDAD: CANTIDAD,
            DESCUENTO: DESCUENTO,
            VALOR_UNI: VALOR_UNI,
            CONTROL_VALOR_UNI: CONTROL_VALOR_UNI,
            VALOR_DCTO: VALOR_DCTO,
            VALOR_IVA: VALOR_IVA,
            PORCENTAJE_IVA: 0,
            TOTAL: 0
        })

        this.setState({
            detalle_factura: newdetalle,
            ID_ITEMS: "",
            DESCRIPCION_ITEM: "",
            CANTIDAD: 0,
            DESCUENTO: 0,
            VALOR_UNI: 0,
            CONTROL_VALOR_UNI: 0,
            VALOR_DCTO: 0,
            VALOR_IVA: 0,
            showAlertItem: true
        })
        this.calcTotales();
    }
    render() {
        const { clientes } = this.state;
        const { forma_pago } = this.state;
        const { vendedores } = this.state;
        const { detalle_factura } = this.state;
        const { cod_lista } = this.state;
        const { data_items } = this.state;
        const { totales } = this.state;
        const { currentUser } = this.state;
        const { numeroDocumento } = this.state;
        const { showAlert } = this.state;
        const { showAlertItem } = this.state;
        const { tope } = this.state;
        const { mensajeerror } = this.state;
        const { showAlertError } = this.state;
        const { changeFormaPago } = this.state;
        const changeCantidad = this.changeCantidad;
        const removeitem = this.removeitem;
        const modifyitem = this.modifyitem;
        const saveInvoice = this.saveInvoice;
        return (

            <div className="contenedor">
                {showAlert &&
                    <Alert variant='success'>
                        El pedido No {numeroDocumento} se creo satisfactoriamente.
                    </Alert>
                }
                {showAlertError &&
                    <Alert variant='danger'>
                        {mensajeerror}
                    </Alert>
                }
                {showAlertItem &&
                    <Alert variant='success'>
                        El item se añadio al pedido satisfactoriamente.
                    </Alert>
                }
                <Nav fill variant="tabs" defaultActiveKey="/home">
                    <Nav.Item>
                        <Nav.Link onClick={this.changetocab} eventKey="link-1"><FcHome /> </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                        <Nav.Link onClick={this.changetonew} eventKey="link-2"><FcPlus /></Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                        <Nav.Link onClick={this.changetodet} eventKey="link-2"><FcPaid /></Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                        <Nav.Link onClick={this.changetotot} eventKey="link-3"><FcShipped /></Nav.Link>
                    </Nav.Item>
                </Nav>

                <Collapse in={this.state.showTotales}>
                    <Table>
                        <tbody>
                            <tr>
                                <td>TOTAL BRUTO</td>
                                <td>{totales.TOTAL_BRUTO}</td>
                            </tr>
                            <tr>
                                <td>TOTAL DESCUENTOS</td>
                                <td>{totales.TOTAL_DESCUENTOS}</td>
                            </tr>
                            <tr>
                                <td>SUBTOTAL</td>
                                <td>{totales.SUBTOTAL}</td>
                            </tr>
                            <tr>
                                <td>TOTAL IVA</td>
                                <td>{totales.TOTAL_IVA}</td>
                            </tr>
                            <tr>
                                <td>RETENCIONES</td>
                                <td>{totales.RETENCION}</td>
                            </tr>
                            <tr>
                                <td>TOTAL</td>
                                <td>{totales.TOTAL_PAGAR}</td>
                            </tr>
                        </tbody>
                    </Table>
                </Collapse>
                <Collapse in={this.state.showDetalle}>
                    <div>
                        {detalle_factura.map(function (element, index) {
                            return <CardItem key={'card' + index} data={element} removeitem={removeitem} modifyitem={modifyitem} index={index}></CardItem>
                        })}
                        {/* <Button className="m-2" onClick={clearItem} disabled={detalle_factura.length === 0} >Limpiar</Button> */}
                    </div>
                </Collapse>
                <Collapse in={this.state.showNuevo}>
                    <Form onSubmit={this.addItem}>
                        {/* <Form.Control type="text" value={this.state.ITEM_SELECT}  readOnly/> */}
                        {this.state.ITEM_SELECT === -1 && <SearchItem data={data_items} event={this.changeItem} clean={true} ></SearchItem>}
                        <Form.Control type="text" value={this.state.DESCRIPCION_ITEM} readOnly />
                        <Form.Group controlId="formBasicEmail">
                            <Form.Label>Cantidad</Form.Label>
                            <Form.Control name="CANTIDAD" min="0" step="0.01" type="number" onChange={(e) => changeCantidad(e)} value={this.state.CANTIDAD} />
                        </Form.Group>

                        <Form.Group controlId="formBasicPassword">
                            <Form.Label>Descuento</Form.Label>
                            <Form.Control name="DESCUENTO" min="0" max={tope} type="number" onChange={(e) => changeCantidad(e)} value={this.state.DESCUENTO} disabled={this.state.currentUser !== "0" || this.state.tipo === "3"} />
                        </Form.Group>

                        <Form.Group controlId="formBasicPassword">
                            <Form.Label>Precio</Form.Label>
                            <Form.Control name="VALOR_UNI" min="0" type="number" onChange={(e) => changeCantidad(e)} disabled={cod_lista !== 0} value={this.state.VALOR_UNI} />
                        </Form.Group>

                        {this.state.ITEM_SELECT === -1 && <Button className="m-2" variant="primary" type="submit">Agregar Item</Button>}
                        {this.state.ITEM_SELECT !== -1 && <Button className="m-2" variant="primary" onClick={this.updateItem} >Modificar Item</Button>}
                        {this.state.ITEM_SELECT !== -1 && <Button className="m-2" variant="danger" onClick={this.candelEdit} >Cancelar</Button>}
                    </Form>
                </Collapse>
                <Form onSubmit={saveInvoice}>
                    <Collapse in={this.state.showCabecera}>
                        <div>
                            <Form.Label>CLIENTE</Form.Label>
                            <SearchCliente data={clientes} event={this.changeCliente} ></SearchCliente>
                            {changeFormaPago.toString() === "1" && <Form.Row>
                                <Form.Group as={Col} controlId="">
                                    <Form.Label>FORMA DE PAGO</Form.Label>
                                    <Form.Control as="select" onChange={(e) => this.setState({ FORMA_PAGO: e.target.value })} value={this.state.FORMA_PAGO} required >
                                        <option value="">Seleccione</option>
                                        {forma_pago.map(function (currentData, index) {
                                            return <option key={'p' + index} value={currentData.ID_FORMAS_PAGO}>{currentData.DESCRIPCION_FORMA_PAGO}</option>;
                                        })}
                                    </Form.Control>
                                </Form.Group>
                            </Form.Row>}
                            <Form.Row>
                                <Form.Group as={Col} controlId="">
                                    <Form.Label>FECHA ENTREGA</Form.Label>
                                    <Form.Control type="date" onChange={e => this.setState({ FECHA_ENTREGA: e.target.value })} value={this.state.FECHA_ENTREGA} required />
                                </Form.Group>
                            </Form.Row>

                            {currentUser === "0" && <Form.Row><Form.Group as={Col} controlId="">
                                <Form.Label>VENDEDOR</Form.Label>
                                <Form.Control as="select" onChange={(e) => this.setState({ VENDEDOR_SELECTED: e.target.value })} value={this.state.VENDEDOR_SELECTED} required >
                                    <option value="">Seleccione</option>
                                    {vendedores.map(function (currentData, index) {
                                        return <option key={'p' + index} value={currentData.ID_USUARIO}>{currentData.NOMBRE_COMPLETO}</option>;
                                    })}
                                </Form.Control>
                            </Form.Group></Form.Row>}
                            <Form.Row>
                                <Form.Label>OBSERVACIONES</Form.Label>
                                <Form.Control as="textarea" rows="5" onChange={(e) => this.setState({ OBSERVACION_FACTURA: e.target.value.toUpperCase() })} value={this.state.OBSERVACION_FACTURA} />

                            </Form.Row>
                        </div>
                    </Collapse>
                    {(this.state.SHOW_DETAIL && !this.state.showNuevo) &&
                        <Button className="m-2" type="submit" disabled={detalle_factura.length === 0}>Finalizar Pedido</Button>
                    }
                </Form>
            </div>
        );
    }
}
export default (Pedidos);


// WEBPACK FOOTER //
// ./src/components/bussines/pedidos/pedidosMovil.jsx